import { render, staticRenderFns } from "./OtherFileViewer.vue?vue&type=template&id=40773e9a&"
import script from "./OtherFileViewer.vue?vue&type=script&lang=js&"
export * from "./OtherFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./OtherFileViewer.vue?vue&type=style&index=0&id=40773e9a&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40773e9a')) {
      api.createRecord('40773e9a', component.options)
    } else {
      api.reload('40773e9a', component.options)
    }
    module.hot.accept("./OtherFileViewer.vue?vue&type=template&id=40773e9a&", function () {
      api.rerender('40773e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/FileViewers/OtherFileViewer.vue"
export default component.exports